import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const betaBadgeStyleParts = ['container', 'contentContainer', 'text'] as const

const helpers = createMultiStyleConfigHelpers(betaBadgeStyleParts)

export const BetaBadgeStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentContainer: {
      height: '1.25rem',
      px: '0.25rem',
      alignItems: 'center',
      gap: '0.375rem',
      background: 'brand.solid',
      userSelect: 'none',
      borderRadius: '0.25rem',
    },
    text: {
      ...textStyles[textStyleKeys.Body4_Bold],
      color: 'brand.contrast',
    },
  },
})

export const useBetaBadgeStyles = () =>
  mergeMultiStyleConfig(BetaBadgeStyle) as MultiStyleType<
    typeof betaBadgeStyleParts
  >
